import { assignment_content_sizes } from 'config';


export function parseForFrontend (content, assetList) {
    let returnContent = content;

    const getSizes = (str) => {
        const sizes = assignment_content_sizes.split(',')
        const low_str = str.toLowerCase();
        switch(low_str) {
            case('sm'): {
                return sizes[0] + 'px'
            }
            case('md'): {
                return sizes[1] + 'px'
            }
            case('lg'): {
                return sizes[2] + 'px'
            }
            default: {
                return '200px'
            }
        }
    }

    const getPosition = (str) => {
        const low_str = str.toLowerCase();
        switch(low_str) {
            case('left'): {
                return '';
            }
            case('center'): {
                return "display: block; margin-left: auto; margin-right: auto;";
            }
            case('right'): {
                return "display: block; margin-left: auto;";
            }
            default: {
                return '';
            }
        }
    }

    const video = ['mp3', 'mp4', 'mov', 'avi', 'wmv'];
    const img = ['jpg', 'jpeg', 'png', 'svg', 'gif', 'tiff', 'bmp'];

    const tags = content.match(/\[(.*?)\]/g);

    if (!tags) {
        return returnContent
    }

    tags.forEach(tag => {
        const clean_tag = tag.replace('[', '').replace(']', '');
        const split_tag = clean_tag.split('-');
        const foundAsset = assetList.find(a => a.header.AssetTag === split_tag[0]);
        if (!foundAsset) {
            return false
        };
        let replaceTag = '';
        if (video.includes(foundAsset.header.AssetFormat)) {
            replaceTag = `<video style='height: ${getSizes(split_tag[1])}; ${getPosition(split_tag[2])}' controls> <source src='${foundAsset.header.URL}' type='video/${foundAsset.header.AssetFormat}'></video>`
        }
        else {
            replaceTag = `<img src='${foundAsset.header.URL}' style='height: ${getSizes(split_tag[1])}; ${getPosition(split_tag[2])}' />`;
        }
        returnContent = returnContent.split(tag).join(replaceTag)
    });

    return returnContent;
}


// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentContentParse.js